import React from 'react'
import { useNode } from '@craftjs/core'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { defaultProps, dynamicProps } from './index'

export const overflowOpts = [
  { label: 'Default', value: '' },
  { label: 'Sinistra', value: 'left' },
  { label: 'Destra', value: 'right' },
]

export const FigureSettings = props => {
  const { customs } = useNode(node => ({
    customs: node.data.custom,
  }))

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        {!props.floating && (
          <>
            <ToolbarItem
              propKey="block"
              propSubKey="src"
              type="text"
              label="Src"
              description="Paste your url or upload a file"
              dynamic={dynamicProps.includes('src') && customs.dynamicData}
              dynamicValues={customs.dynamicData ? getAllPaths(customs.dynamicData) : []}
              defaultValue={defaultProps['src']}
            />
            <ToolbarItem propKey="block" propSubKey="src" type="file" />
          </>
        )}
        <ToolbarItem
          propKey="block"
          propSubKey="alt"
          type="text"
          label="Alt Text"
          dynamic={dynamicProps.includes('alt') && customs.dynamicData}
          dynamicValues={customs.dynamicData ? getAllPaths(customs.dynamicData) : []}
          defaultValue={defaultProps['alt']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="zoommabile"
          type="switch"
          label="Immagine zoommabile"
          dynamic={dynamicProps.includes('zoommabile') && customs.dynamicData}
          dynamicValues={customs.dynamicData ? getAllPaths(customs.dynamicData) : []}
          defaultValue={defaultProps['zoommabile']}
        />
      </ToolbarSection>
      <ToolbarSection title="Style" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="overflow"
          type="select"
          label="Overflow"
          options={overflowOpts}
          dynamic={dynamicProps.includes('overflow') && customs.dynamicData}
          dynamicValues={customs.dynamicData ? getAllPaths(customs.dynamicData) : []}
          defaultValue={defaultProps['overflow']}
        />
      </ToolbarSection>
    </>
  )
}

export const FigureFloatingSettings = () => React.createElement(FigureSettings, { floating: true })
